import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { Props } from './types.js';

/** Position Preset `<Icon>` component. */
export const Icon = ({ className, ...props }: Props): ReactElement => (
  <svg
    className={twMerge('h-[75px] w-[75px] fill-current', className)}
    role='img'
    viewBox='0 0 75 75'
    {...props}
  >
    <path d='M37.5,18.4c-6.5,0-11.8,5.3-11.8,11.8S31,41.9,37.5,41.9c6.5,0,11.8-5.3,11.8-11.8S44,18.4,37.5,18.4z M37.5,40.4c-5.7,0-10.3-4.6-10.3-10.3s4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3S43.2,40.4,37.5,40.4z' />
    <path d='M37.5,0C20.9,0,7.3,13.5,7.3,30.2C7.3,45.4,20,58,33.4,71.3c1.2,1.2,2.3,2.3,3.5,3.5c0.2,0.2,0.3,0.2,0.5,0.2 c0.2,0,0.4-0.1,0.5-0.2c1.2-1.2,2.4-2.3,3.5-3.5C55,58,67.7,45.4,67.7,30.2C67.7,13.5,54.1,0,37.5,0z M40.5,70.2c-1,1-2,2-3,3 c-1-1-2-2-3-3C21.3,57.1,8.9,44.8,8.9,30.2c0-15.8,12.8-28.6,28.6-28.6c15.8,0,28.6,12.8,28.6,28.6C66.1,44.8,53.7,57.1,40.5,70.2z' />
  </svg>
);
